import "./styles.scss";

import classnames from "classnames";

import { ReactComponent as CheckIcon } from "assets/icons/new/check.svg";

const mainClass = "check-button";

const CheckButton = ({ checked, onClick }) => {
  return (
    <button
      className={classnames(mainClass, {
        [`${mainClass}--checked`]: !!checked,
      })}
      type="button"
      disabled={typeof onClick !== "function"}
      onClick={onClick}
    >
      <CheckIcon />
    </button>
  );
};

export default CheckButton;
